import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import Chatbot from "../pages/Chatbot/";
import Supervisor from "../pages/Supervisor/";
import InternalChat from "../pages/InternalChat/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";
import ErrorBoundary from "../components/ErrorBoundary";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate roles={["admin", "supervisor"]} />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate roles={["admin"]} />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate roles={["admin"]} />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate roles={["admin"]} />
                <Route exact path="/Settings" component={Settings} isPrivate roles={["admin"]} />
                <Route exact path="/Queues" component={Queues} isPrivate roles={["admin"]} />
                <Route exact path="/chatbot" component={Chatbot} isPrivate roles={["admin"]} />
                <Route exact path="/supervisor" component={Supervisor} isPrivate roles={["admin", "supervisor"]} />
                <Route exact path="/internal-chat" component={InternalChat} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
